module.exports = __webpack_public_path__ + "static/laptop-ab491a468f7c6819b17bc40012c660ce.png";